import { useQuery } from '@tanstack/react-query';
import {
  getEstadisticasJugadorById,
  getJugadorEstaditicasByIdGrupoAndIdTemporada,
  getJugadorEstaditicasByIdCompeticionAndIdTemporada,
  getJugadorEstaditicasByIdAndIdTemporada,
} from '../../services/jugadorEstadisticasService';

/**
 * Hook para obtener estadísticas de jugadores por grupo y temporada
 * @param {number} idGrupo - ID del grupo
 * @param {number} idTemporada - ID de la temporada
 * @param {object} options - Opciones adicionales de React Query
 */
export const useJugadorEstadisticas = (idGrupo, idTemporada, options = {}) => {
  return useQuery({
    queryKey: ['jugadorEstadisticas', idGrupo, idTemporada],
    queryFn: async () => {
      const navigate = null;
      return await getJugadorEstaditicasByIdGrupoAndIdTemporada(
        idGrupo,
        idTemporada,
        navigate
      );
    },
    enabled: !!(idGrupo && idTemporada),
    ...options,
  });
};

/**
 * Hook para obtener estadísticas de jugadores por competición y temporada
 * @param {number} idCompeticion - ID de la competición
 * @param {number} idTemporada - ID de la temporada
 * @param {object} options - Opciones adicionales de React Query
 */
export const useJugadorEstadisticasByCompeticion = (idCompeticion, idTemporada, options = {}) => {
  return useQuery({
    queryKey: ['jugadorEstadisticas', 'competicion', idCompeticion, idTemporada],
    queryFn: async () => {
      const navigate = null;
      return await getJugadorEstaditicasByIdCompeticionAndIdTemporada(
        idCompeticion,
        idTemporada,
        navigate
      );
    },
    enabled: !!(idCompeticion && idTemporada),
    ...options,
  });
};

/**
 * Hook para obtener estadísticas de un jugador específico en una temporada
 * @param {number} idJugador - ID del jugador
 * @param {number} idTemporada - ID de la temporada
 * @param {object} options - Opciones adicionales de React Query
 */
export const useJugadorEstadisticasById = (idJugador, idTemporada, options = {}) => {
  return useQuery({
    queryKey: ['jugadorEstadisticas', 'byId', idJugador, idTemporada],
    queryFn: async () => {
      const navigate = null;
      return await getJugadorEstaditicasByIdAndIdTemporada(
        idTemporada,
        idJugador,
        navigate
      );
    },
    enabled: !!(idJugador && idTemporada),
    ...options,
  });
};

/**
 * Hook para obtener estadísticas de un jugador en todas las temporadas
 * @param {number} idJugador - ID del jugador
 * @param {object} options - Opciones adicionales de React Query
 */
export const useEstadisticasJugadorAllSeasons = (idJugador, options = {}) => {
  return useQuery({
    queryKey: ['jugadorEstadisticas', 'allSeasons', idJugador],
    queryFn: () => getEstadisticasJugadorById(idJugador, null),
    enabled: !!idJugador,
    ...options,
  });
};
